import FilterMenuButton from '@components/filters/FilterMenuButton';
import OptionFilterPanel from '@components/filters/OptionFilterPanel';
import LocationFilterPanel from './LocationFilterPanel';
import { Action } from '../types';
import type { LocationSummary } from '../../../networkRequest/locationsService';
import { FilterState } from './filterState';

type ClearancesFilterMenuButtonProps = {
  locationFilters: LocationSummary[];
  actionFilters: Action[];
  filterState: FilterState;
  onFilterChange: (newState: FilterState) => void;
  disabled?: boolean;
};

const ClearancesFilterMenuButton: React.FC<ClearancesFilterMenuButtonProps> = ({
  locationFilters,
  actionFilters,
  filterState,
  onFilterChange,
  disabled = false,
}) => {
  const menuItems = [
    {
      key: 'location',
      label: 'Location',
      panelContent: (
        <LocationFilterPanel
          locationFilters={locationFilters}
          filterState={filterState}
          onFilterChange={onFilterChange}
        />
      ),
    },
    {
      key: 'action',
      label: 'Action',
      panelContent: (
        <OptionFilterPanel
          options={actionFilters}
          selected={filterState.actions}
          onChange={(newActions) => onFilterChange({ ...filterState, actions: newActions })}
        />
      ),
    },
  ];

  return <FilterMenuButton menuItems={menuItems} disabled={disabled} />;
};

export default ClearancesFilterMenuButton;
